var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehaviour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89838 10.8508C8.4941 10.8508 7.35595 9.71265 7.35595 8.30841C7.35595 6.90418 8.49415 5.76599 9.89838 5.76599C11.3026 5.76599 12.4408 6.90418 12.4408 8.30841C12.4408 9.71239 11.3026 10.8508 9.89838 10.8508ZM5.94352 14.5233V15.6532H13.8535V14.5233C13.8535 12.963 12.5889 11.6984 11.0286 11.6984H8.76865C7.20816 11.6982 5.94352 12.963 5.94352 14.5233ZM18.6542 6.18832C16.9401 2.97505 13.5714 0.930298 9.89838 0.930298C6.01099 0.930298 2.46241 3.21893 0.857511 6.76107C0.691034 7.12817 0.853989 7.56073 1.22143 7.72751C1.58827 7.89312 2.02113 7.73129 2.18787 7.36358C3.55649 4.34277 6.58284 2.39088 9.89838 2.39088C12.9995 2.39088 15.8471 4.09916 17.3226 6.792L16.0209 7.38167L19.5712 9.92615L20 5.57907L18.6542 6.18832ZM18.4524 14.2969C18.0917 14.1162 17.653 14.2637 17.4727 14.624C16.0296 17.5149 13.1271 19.3111 9.89808 19.3111C6.88277 19.3111 4.15342 17.7442 2.63004 15.1828L3.90899 14.5446L0.26608 12.1345L0 16.4947L1.32099 15.8358C3.09589 18.8952 6.32552 20.7714 9.89808 20.7714C13.6841 20.7714 17.0873 18.6657 18.7792 15.2763C18.9597 14.9152 18.8131 14.4769 18.4524 14.2969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.85083)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviour);
export default __webpack_public_path__ + "static/media/behaviour.c12371358acb5195d3ad7540cdbb1958.svg";
export { ForwardRef as ReactComponent };